<!--
  * name: brand story
  * description: [Main] brand story 컴포넌트 페이지
-->
<template>
  <div>
    <bread-crumb location="brand story"></bread-crumb>
    <!-- 병헌 : 경로 -->
    <section-1 />
    <section-2 />
    <section-3 />
    <section-8 />
    <!-- <section-6 /> -->
    <section-7 />
    <section-4 />
    <!-- <section-5 :productList="productList"/> -->
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import $ from 'jquery';
// eslint-disable-next-line import/no-extraneous-dependencies
// import AOS from 'aos';
// import '@/assets/plugins/aos.css';;
import BreadCrumb from '@/components/breadcrumb/BreadCrumb.vue';
import Section1 from './partial/Section1.vue';
import Section2 from './partial/Section2.vue';
import Section3 from './partial/Section3.vue';
import Section4 from './partial/Section4.vue';
// import Section6 from './partial/Section6.vue';
import Section7 from './partial/Section7.vue';
import Section8 from './partial/Section8.vue';

export default {
  name: 'BrandStory',
  components: {
    BreadCrumb,
    Section1,
    Section2,
    Section3,
    Section4,
    // Section6,
    Section7,
    Section8,
  },
};
</script>

<style lang='scss' scoped>
@import '@/assets/css/brandstory.scss';
</style>
